import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {state} from 'lit/decorators/state.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';

import {FeatureSelect} from './featureSelect';

import radio from '../../../icons/radio';


@customElement('feature-choice-select')
export class FeatureChoiceSelect extends FeatureSelect {

	static styles = [
		FeatureSelect.styles,
		css`
			:host {
			}

			.active button {
				height: 0;
				opacity: 0;
				padding: 0;
			}

			.title {
				display: flex;
				align-items: center;
				font-family: var(--font-family-light);
				font-size: var(--font-size-widget);
				color: var(--color-text-widget-title);
				height: var(--height-title);
			}

			.title {
				display: flex;
				align-items: center;
				font-family: var(--font-family-light);
				font-size: var(--font-size-widget);
				color: var(--color-text-widget-title);
				height: var(--height-title);
			}

			.list {
				overflow: auto;
				margin-top: 0em;
			}

			.values {
				display: flex;
				flex-direction: column;
				border: var(--border-widget);
				overflow-y: auto;
				max-height: 300px;
			}

			.values.notSatisfied {
				border-left-color: var(--color-warn);
			}

			.icon {
				width: 11px;
				height: 11px;
				padding: 5px;
				display: inline-block;
			}

			.icon svg {
				display: block;
				fill: currentColor
			}

			.satisfied {
				color: var(--color-text-widget-title);
			}

			.icon.satisfied {
				color: var(--color-grey5);
			}

			.notSatisfied {
				color: var(--color-warn);
			}
			.info {
				display: block;
				overflow: hidden;
				font-family: var(--font-family-light);
				font-size: var(--font-size-widget);
				color: var(--color-text-widget);
				background-color: transparent;
				border: 0 none;
				//height: var(--height-widget);

				line-height: 120%;
				margin: 0;
				cursor: pointer;
				width: 100%;
				text-align: left;
			}
			.item button {
				height: var(--height-widget);
				background-color: var(--color-background-widget);
				font-family: var(--font-family-monospace), monospace;
				font-size: var(	--font-size-widget-small-mono);
				color: var(--color-white);
				transition: background-color 0.4s, color 0.4s;
				padding: 0.5em 0.5em;
				line-height: 120%;
				margin: 0;
				border: var(--border-widget);
				cursor: pointer;
				width: 100%;
				text-align: left;
				overflow: hidden;
			}
			.active button {
				height: 0;
				opacity: 0;
				padding: 0;
			}
        `];

	@state()
	_active = false;

	activate() {
		this._active = true;
	}
	deactivate() {
		this._active = false;
		this.search = '';
	}
	onBlur() {
		setTimeout(() => {
			this.deactivate();
			}, 1000);
	}

	constructor() {
		super();
		this.addEventListener('activate-combo', (e) => {
			this.activate();
			e.target.value = '';
		});
		this.addEventListener('deactivate-combo', (e) => {
			this.deactivate();
			e.target.value = '';
		});
		this.addEventListener('select-value', (e) => {
			e.target.value = '';
		});
	}

	normalize(str) {
		return str.replace(/[\n\r\s\t]+/g, '').toLowerCase();
	}

	render() {
		return html`
			<div>
				<div class="title">
					${when(this.isSatisfied(), () => html`
						<span class="icon satisfied">${radio}</span>
					`, () => html`
						<span class="icon notSatisfied">${radio}</span>
					`)}
					<trans-label
							key="${this.feature.variableId}"
							context="F"
							title="${this.feature.variableId}">
					</trans-label>
					${when(this.hasFeatureDescription(), () => html`
						<button class="info" @click="${this.openModal}">
							Info
						</button>
					`)}
				</div>
			${when(!this.isSatisfied() && !this._active, () => html`
						<div class="item">
							<button @click="${this.activate}">${msg('Please select')}</button>
						</div>
					`)}
			<div @focus="${this.activate}" class="list">
				${repeat(this.feature.values,
					(featureValue) => featureValue.featureValueId,
					(featureValue) => html`
						<feature-choice-select-item class="item"
													.satisfied=${this.isSatisfied()}
												   .active=${this._active}
													.hideDisabled=${this.hideDisabled}
												   .feature=${this.feature}
												   .featureValue=${featureValue}
												   .productData=${this.getProductData(featureValue.featureValueId)}
												    >
						</feature-choice-select-item>
					`)}
			</div>

			</div>
		`;
	}
}
